import { analysisClient } from "@/shared/lib/supabase";

export const analysisDelete = {
  delete: (analysisId: string) =>
    analysisClient.from("analysis").delete().eq("analysis_id", analysisId),
};
